// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/plug.js';

import { paths } from '../generated/plug';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('plug', Original, paths);
